import { render, staticRenderFns } from "./InventoryTargeting.vue?vue&type=template&id=45296c62&"
import script from "./InventoryTargeting.vue?vue&type=script&lang=js&"
export * from "./InventoryTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports